import { css } from '@emotion/react'

export const full = css`
  height: 100%;
`

export const loaderWrapper = css`
  min-height: 108px;
`
